// extracted by mini-css-extract-plugin
module.exports = {"circleNumber":"_2YX6Q"};